import { Injectable } from '@angular/core';
import { EnvService } from '@core-mkt/services/env/env.service';
import { QueryParamService } from '@core-mkt/services/query-param/query-param.service';
import { CouponUseCases } from './coupon-use-cases';

@Injectable({
  providedIn: 'root',
})
export class CouponQueryResolverService {
  constructor(private env: EnvService, private queryParamService: QueryParamService) {}

  /**
   * Returns the appropriate coupon query parameter name based on the provided use case
   * and the current coupon strategy configuration.
   *
   * @param useCase - The coupon use case, typically one of the values from `CouponUseCases`.
   * @returns The query parameter name to be used for the given use case.
   */
  setCouponQueryParam(useCase: string): string {
    // Used for testing, `ocs` query stands for old coupon strategy
    const oldCouponStrategy =
      this.env.get.brandConfig.use_old_coupon_strategy || this.queryParamService.getQueryParam('ocs') === '0';

    const mapping: { [key: string]: string } = {
      [CouponUseCases.SALES]: !oldCouponStrategy ? this.env.get.brandConfig.globalSalesQueryParam : 'couponCode',
      [CouponUseCases.CDI]: !oldCouponStrategy ? this.env.get.brandConfig.globalCDIQueryParam : 'coupon',
    };

    return mapping[useCase];
  }
}
